import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { MarcaVeiculoService } from '../services/marca-veiculo.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-marca-veiculo-edit',
	templateUrl: './marca-veiculo-edit.component.html',
	styleUrls: ['./marca-veiculo-edit.component.css'],
	animations: [loadingFade]
})
export class MarcaVeiculoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public marca_veiculo_id = null;

	public formMarcaVeiculo: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private marcaVeiculoSvc: MarcaVeiculoService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.marca_veiculo_id = params.id;
				// pega dados a partir do id
				this.marcaVeiculoSvc.getMarcaVeiculo(params.id).then((data: any) => {
					this.preencheForm({
						marca_veiculo_id: data.marca_veiculo_id,
						marca_veiculo_nome: data.marca_veiculo_nome
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formMarcaVeiculo = this.fb.group({
			marca_veiculo_id: null,
			marca_veiculo_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formMarcaVeiculo.setValue(dados);
	}

	enviaMarcaVeiculo() {
		if (this.formMarcaVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formMarcaVeiculo.value;

			if (this.marca_veiculo_id === null) { // criar
				this.marcaVeiculoSvc.criaMarcaVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Marca criada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/marcasveiculo']);
						}
					});

				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.marcaVeiculoSvc.editaMarcaVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Marca alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/marcasveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formMarcaVeiculo.controls){
				let campo = this.formMarcaVeiculo.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formMarcaVeiculo.get(nome);
		return input.touched && input.invalid;
	}
}
